/**
 * header 返回按钮
 */

import React from 'react'
import './index.less'

export function HeaderBackBtn() {
    const click = function () {
        let refer_dictionary = ['18.cn', '1234567.com.cn', '18.com.cn', 'eastmoney.com']
        let this_refer = document.referrer
        let isEM
        if (!this_refer) {
            window.location.href = '/'
        } else {
            for (let i = 0; i < refer_dictionary.length; i++) {
                if (this_refer.indexOf(refer_dictionary[i]) > -1) {
                    isEM = true
                    break
                } else {
                    isEM = false
                }
            }
            if (isEM) {
                if (window.history.length > 1) {
                    window.history.go(-1)
                } else {
                    window.location.href = '/'
                }
            } else {
                window.location.href = '/'
            }
        }
    }

    return <a href="#" className="headerbackbtn" onClick={(e)=>{e.preventDefault();click();}}></a>
}

export function StockMoreHeaderBackBtn(props:{market:number,code:string}) {
    const click = function () {
        window.location.href = `/quote/stock/${props.market}.${props.code}.html`
    }

    return <a href="#" className="headerbackbtn" onClick={(e)=>{e.preventDefault();click();}}></a>
}
